import { get } from 'lodash';

// local dependencies
import { HttpService } from 'core/modules/network-service';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { getVisibleItems } from 'resolvers/getVisibleEntities';

/*************************************************************/

/**
 * @type {class}
 * @desc TrendsReports defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { TrendsReportsService } from 'services/trendsReports';
 *
 * // create service instance and send/cancel request
 * const trendsReportsService = new TrendsReportsService();
 * const result = await trendsReportsService.fetchData( '<user-id>' ); // fetch data
 * trendsReportsService.cancel(); // cancel an active request
 */
export class TrendsReportsService extends HttpService {

    // make request and fetch data
    async fetchComponentData( { url = {}, data = {} } = {} ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data,
            } );

            // extract widgets from the response
            const widgets = get( response, 'body.component.structure.widgets', {} );
            const visibility = get( response, 'body.component.visibility', {} );
    
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: {
                    widgets: getVisibleItems( widgets, visibility ),
                },
            };
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }
}
